/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShockEventList
 */
export interface ShockEventList {
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventList
     */
    userFullName: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventList
     */
    shockEventMotionStatus: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventList
     */
    vehicleSerialNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventList
     */
    departmentLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventList
     */
    vehicleGroupLabel: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShockEventList
     */
    shockProfileLabel: boolean;
}

/**
 * Check if a given object implements the ShockEventList interface.
 */
export function instanceOfShockEventList(value: object): value is ShockEventList {
    if (!('userFullName' in value) || value['userFullName'] === undefined) return false;
    if (!('shockEventMotionStatus' in value) || value['shockEventMotionStatus'] === undefined) return false;
    if (!('vehicleSerialNumber' in value) || value['vehicleSerialNumber'] === undefined) return false;
    if (!('departmentLabel' in value) || value['departmentLabel'] === undefined) return false;
    if (!('vehicleGroupLabel' in value) || value['vehicleGroupLabel'] === undefined) return false;
    if (!('shockProfileLabel' in value) || value['shockProfileLabel'] === undefined) return false;
    return true;
}

export function ShockEventListFromJSON(json: any): ShockEventList {
    return ShockEventListFromJSONTyped(json, false);
}

export function ShockEventListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShockEventList {
    if (json == null) {
        return json;
    }
    return {
        
        'userFullName': json['userFullName'],
        'shockEventMotionStatus': json['shockEventMotionStatus'],
        'vehicleSerialNumber': json['vehicleSerialNumber'],
        'departmentLabel': json['departmentLabel'],
        'vehicleGroupLabel': json['vehicleGroupLabel'],
        'shockProfileLabel': json['shockProfileLabel'],
    };
}

export function ShockEventListToJSON(json: any): ShockEventList {
    return ShockEventListToJSONTyped(json, false);
}

export function ShockEventListToJSONTyped(value?: ShockEventList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userFullName': value['userFullName'],
        'shockEventMotionStatus': value['shockEventMotionStatus'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'departmentLabel': value['departmentLabel'],
        'vehicleGroupLabel': value['vehicleGroupLabel'],
        'shockProfileLabel': value['shockProfileLabel'],
    };
}

